.field {
  background-color: var(--colors-grays-white);
  border-radius: 25px;
  border: 1px solid var(--colors-grays-light);
  display: grid;
  grid-template-columns: 36px 1fr fit-content(44px);
  height: 48px;
}

.input {
  border: none;
  border-radius: 25px;
  outline: none;
  text-overflow: ellipsis;
  width: 100%;
}

.startIcon {
  margin: auto;
  margin-left: 12px;
}

.clearIcon {
  margin: auto;
  margin-right: 12px;

  & path {
    fill: var(--colors-grays-dark);
  }
}
